export default __webpack_public_path__ + "static/media/ecommerce_website.ae59058c.png";